module.exports = __webpack_public_path__ + "img/code.1d7e850b.jpeg";